'use client';

import React from 'react';
import { FISSION_CHAIN, FISSION_CONNECTIONS } from '../data/irlLensData';

export default function FissionDiagram() {
  const W = 400;
  const H = 340;

  const nodeMap = Object.fromEntries(FISSION_CHAIN?.map(n => [n?.id, n]));

  return (
    <div className="border border-white/10 bg-black/40 p-4">
      <div className="font-mono text-[10px] tracking-widest text-white/40 mb-3 uppercase">Fikr Chain — Observation → Allah</div>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full max-w-[400px] mx-auto">
        {/* Connection lines */}
        {FISSION_CONNECTIONS?.map((conn, i) => {
          const from = nodeMap?.[conn?.from];
          const to = nodeMap?.[conn?.to];
          if (!from || !to) return null;
          const x1 = (from.x / 100) * W;
          const y1 = (from.y / 100) * H + 16;
          const x2 = (to?.x / 100) * W;
          const y2 = (to?.y / 100) * H - 16;
          const mx = (x1 + x2) / 2;
          const my = (y1 + y2) / 2;
          return (
            <g key={i}>
              <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(255,255,255,0.2)" strokeWidth="1" strokeDasharray="3 2" />
              {/* Arrow */}
              <polygon
                points={`${x2},${y2} ${x2 - 4},${y2 - 8} ${x2 + 4},${y2 - 8}`}
                fill="rgba(255,255,255,0.3)"
              />
              {/* Label */}
              <text x={mx + 4} y={my} fill="rgba(255,255,255,0.35)" fontSize="6" fontFamily="monospace">
                {conn?.label}
              </text>
            </g>
          );
        })}

        {/* Nodes */}
        {FISSION_CHAIN?.map((node) => {
          const x = (node?.x / 100) * W;
          const y = (node?.y / 100) * H;
          const isAllah = node?.id === 'allah';
          const isObs = node?.id === 'observation';

          return (
            <g key={node?.id}>
              {isAllah ? (
                <>
                  <circle cx={x} cy={y} r={22} fill="rgba(255,255,255,0.08)" stroke="white" strokeWidth="1" />
                  <circle cx={x} cy={y} r={18} fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" />
                </>
              ) : (
                <rect
                  x={x - 36} y={y - 14}
                  width={72} height={28}
                  fill={isObs ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.04)'}
                  stroke={isObs ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.25)'}
                  strokeWidth="0.5"
                />
              )}
              <text
                x={x} y={isAllah ? y - 5 : y - 3}
                textAnchor="middle"
                fill="white"
                fontSize={isAllah ? '9' : '7'}
                fontFamily="monospace"
                letterSpacing="1"
                fontWeight={isAllah ? 'bold' : 'normal'}
              >
                {node?.label}
              </text>
              <text
                x={x} y={isAllah ? y + 8 : y + 7}
                textAnchor="middle"
                fill="rgba(255,255,255,0.6)"
                fontSize={isAllah ? '10' : '7'}
                fontFamily="serif"
              >
                {node?.arabic}
              </text>
              {!isAllah && (
                <text
                  x={x} y={y + 22}
                  textAnchor="middle"
                  fill="rgba(255,255,255,0.25)"
                  fontSize="5"
                  fontFamily="monospace"
                >
                  {node?.sublabel?.slice(0, 32)}
                </text>
              )}
            </g>
          );
        })}
      </svg>
      <div className="mt-3 font-mono text-[9px] text-white/30 text-center tracking-wider">
        HAWAS (سenses) → FIKR (reflection) → WUJUB (necessity) → ALLAH
      </div>
    </div>
  );
}
